var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0414 10.7582H27.5264C28.2568 12.3147 28.622 14.1459 28.622 15.9771C28.622 22.9814 22.9615 28.7039 15.9315 28.7039C13.7404 28.7039 11.8231 28.1087 9.99713 27.2389H16.2967C18.4879 27.2389 23.5549 26.3691 23.418 20.6009C23.281 16.3434 19.6747 15.382 17.6205 15.2904V17.9457C18.8074 18.1746 20.4964 18.907 20.4964 20.6009C20.4964 23.2561 18.5792 24.3548 16.388 24.3548H2.55634C5.34093 28.9328 10.408 32 16.0685 32C24.8787 32 32 24.8584 32 16.0229C31.863 14.1459 31.4978 12.4521 31.0414 10.7582Z",
    fill: "#074F83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9315 0C7.12126 0 0 7.14163 0 15.9771C0 18.1745 0.50214 20.2346 1.18688 22.02H4.79315C3.83452 20.1888 3.24108 18.1288 3.24108 15.9771C3.24108 8.97282 8.90157 3.25036 15.9315 3.25036C18.7161 3.25036 21.2268 4.12017 23.281 5.67668H15.5663C13.3752 5.67668 8.30813 6.5465 8.44508 12.3147C8.58203 17.1674 13.3752 17.6252 14.9729 17.7625V15.1073C13.8773 14.97 11.3666 14.3748 11.3666 12.3147C11.3666 9.65952 13.2839 8.5608 15.475 8.5608H29.9458C27.3894 3.52504 22.0942 0 15.9315 0Z",
    fill: "#F58220"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvLogo);
export default __webpack_public_path__ + "static/media/sv-logo.9f693cd0c849ed5a06df886922d0afa9.svg";
export { ForwardRef as ReactComponent };